// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation-item_nav-item__teZwQ {
  width: calc(100% - 20px);
  min-height: 24px;
  border-radius: 4px;
  cursor: pointer;
  padding: 4px 10px;
  font-size: 14px;
  gap: 12px;
  display: flex;
  align-items: center;
  background-color: inherit;
  text-decoration: none;
  color: var(--primary-text-color);

  &:hover {
    background-color: var(--hover-primary-color);
  }
}

.navigation-item_active__2gt\\+V {
  background-color: var(--tertiary-background-color);
  font-weight: 500;
  color: var(--tertiary-text-color);

  &:hover {
    background-color: var(--tertiary-background-color);
  }
}

@media (max-width: 1368px) {
  .navigation-item_text__Rul60 {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/navigation-item.module.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;;EAEhC;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,iCAAiC;;EAEjC;IACE,kDAAkD;EACpD;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".nav-item {\n  width: calc(100% - 20px);\n  min-height: 24px;\n  border-radius: 4px;\n  cursor: pointer;\n  padding: 4px 10px;\n  font-size: 14px;\n  gap: 12px;\n  display: flex;\n  align-items: center;\n  background-color: inherit;\n  text-decoration: none;\n  color: var(--primary-text-color);\n\n  &:hover {\n    background-color: var(--hover-primary-color);\n  }\n}\n\n.active {\n  background-color: var(--tertiary-background-color);\n  font-weight: 500;\n  color: var(--tertiary-text-color);\n\n  &:hover {\n    background-color: var(--tertiary-background-color);\n  }\n}\n\n@media (max-width: 1368px) {\n  .text {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nav-item": `navigation-item_nav-item__teZwQ`,
	"active": `navigation-item_active__2gt+V`,
	"text": `navigation-item_text__Rul60`
};
export default ___CSS_LOADER_EXPORT___;
